import isObject from 'lodash/isObject';
import has from 'lodash/has';

/**
 * Return the formatting options for currency
 * @param {Object|String|Number} v
 */
const getCurrencyFormatOptions = v => {
    if (isObject(v) && has(v, 'amount')) {
        v = v.amount;
    }

    let isWholeNumber = v % 1 === 0;

    let decimals = 0;
    let abbreviate = false;
    let minimumFractionDigits = 2;
    let maximumFractionDigits = 2;

    if (v > 999999) {
        decimals = 1;
    }

    if (v > 99999) {
        abbreviate = true;
        minimumFractionDigits = 0;
        maximumFractionDigits = 1;
    }

    if (!abbreviate && isWholeNumber) {
        decimals = 0;
        minimumFractionDigits = 0;
        maximumFractionDigits = 0;
    }

    return { decimals, abbreviate, minimumFractionDigits, maximumFractionDigits };
};

export default getCurrencyFormatOptions;
